export default __webpack_public_path__ + "static/media/underconstruction.c32a81e1.jpeg";